import { User } from '../models/user';

export class CreateUser {
    static readonly type = '[User] CreateUser';

    constructor(public payload: User) {}
}
